import { GlobalStyle } from '../../fonts/fonts.js';
import { FuncVideo } from '../../components/VideoVimeo.js';
import styled from 'styled-components';
import { VLine } from '../../components/VLine.js';
import NODLOGO from '../../img/NODLOGO.jpg';

import { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';

// --------variables globales--------------
import { colorRojoNod } from '../../VariablesGlobales.js';

import { useDispatch, useSelector } from 'react-redux';
import { FullScreen } from '../../redux/PlayReelSlice.js';

import punteroImgPlay from '../../img/puntero/PlayReel.png';
import punteroImgStop from '../../img/puntero/CloseReel.png';

import useMediaQuery from '../../hooks/MediaQueryhook.js';
import SpyGA from '../../Observer.js';

const ContainerAllAboutDelivery = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  background-color: none; //#ef4125;
  width: 30%;
  height: auto;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  padding-top: 0px;
  padding-right: 2.5vw;
  padding-bottom: 0px;
  z-index: 2;
  color: white;
  @media screen and (min-width: 0px) and (max-width: 768px) {
    background-color: ${colorRojoNod};
    color: black;
    padding: 0;
    margin: 0;
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
    width: 100vw;
    height: auto; //aca
    display: none;
    display: grid;
    align-items: end;
    grid-template-columns: repeat(1, 1fr);
  }
  @media screen and (min-width: 769px) and (max-width: 1279px) {
    padding-left: 2.5vw;
  }
  @media screen and (min-width: 1280px) {
    padding-left: 2.5vw;
  }
`;

const LogoChico = styled.div`
  background-image: url(${NODLOGO});
  isolation: isolate;
  mix-blend-mode: multiply;
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  background-size: 100px 100px; //tiene que ser igual al width y al height

  display: flex;
  padding: 0;
  margin: 0;
  @media (max-width: 768px) {
    margin-top: 5px;
    display: block;
    width: 93px;
    height: 93px;
    background-size: 93px 93px;
    padding-right: 10px;
  }
  @media (min-width: 769px) {
    display: none;
  }
`;

const DivIzq = styled.div`
  margin-top: 0px;
  @media (max-width: 768px) {
    display: grid;
    height: 100%;
    width: 100%;
    padding-left: 10px;
  }
`;

const DivDer = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: grid;
    height: 100%;
    width: auto;
  }
`;

const AllADContGridLogText = styled.div`
  margin: 0;
  top: 0px;
  left: 0px;
  width: fit-content;
  height: auto;
  margin-bottom: 2.5vw;

  @media (min-width: 0px) and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-items: flex-start;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 8vw; //5vw; // aca cambio margen a pedido de nacho
    margin-bottom: 8vw; //5vw;
  }
  @media (min-width: 769px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
  }
`;

const AllAboutDeliveryContainerTexto = styled.p`
  margin: 0px;
  font-family: 'Aeroport';
  line-height: 0.8;
  padding-right: 10px;

  @media (min-width: 1px) and (max-width: 768px) {
    font-size: 35px;
    padding-top: 2px;
    padding-right: 15px;
  }
  @media (min-width: 769px) and (max-width: 1109px) {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
    font-size: 50px;
  }

  @media screen and (min-width: 1109px) and (max-width: 1195px) {
    font-size: 50px;
  }
  @media screen and (min-width: 1195px) and (max-width: 1525px) {
    font-size: 70px;
  }
  @media (min-width: 1525px) {
    font-size: 80px;
  }

  letter-spacing: -0.06em;
`;

const ContainerLine = styled.div`
  z-index: 0;
  @media (max-width: 768px) {
    display: none;
  }
`;

const ContLanding = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100dvh;
  background-color: black; //${colorRojoNod};
  margin: 0;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);

    grid-template-rows: ${({ zoom }) => {
      if (zoom == 'Normal') {
        return '1.5fr auto'; // aqui coloco auto para que en modo celular se acomode el video y ocupe todo lo que debe
      } else if (zoom == 'FullScreen') {
        return '1.5fr 1fr';
      } else if (zoom == 'FullScreenCellphone') {
        return '0fr 1fr';
      }
    }};

    width: auto;
    height: 100vh;
  }
`;

const ContVidLanding = styled.div`
  overflow: hidden;
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  background-color: black;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
  opacity: 1;

  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
  }
  @media (max-height: 400px) and (max-width: 768px) {
    //display: none;
  }
  @media screen and (min-width: 0px) and (max-width: 480px) {
    background-color: black;
  }
  @media screen and (min-width: 481px) and (max-width: 768px) {
    background-color: black;
  }
`;

const CointLogoGrand = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  display: grid;
  justify-items: start;
  align-items: start;
  height: 100%;
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin-top: 1rem;
    display: none;
  }
  @media screen and (min-width: 481px) and (max-width: 768px) {
    margin-top: 2.5vw;
    display: none;
  }
  @media screen and (min-width: 769px) and (max-width: 1279px) {
    margin-top: 2.5vw;
  }
  @media screen and (min-width: 1280px) {
    margin-top: 2.5vw;
  }
`;

const ContainerText = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 2;
  grid-row-end: 3;
  margin-bottom: 2.5vw;
  @media (max-width: 768px) {
    height: fit-content; // guarda aca
    margin-bottom: 0;
  }
`;

const HLineMinMax = styled.div`
  width: 100%;
  height: 1px;
  padding-top: 0;
  padding-bottom: 0;
  z-index: 10;
  margin-bottom: ${(props) => props.mBottom};
  margin-top: ${(props) => props.mBottom};
  display: block;
  background-color: white;
  @media (min-width: ${(props) => props.startPx}) and (max-width: ${(props) =>
      props.endPx}) {
    width: ${(props) => props.width};
    left: ${(props) => props.left};
    left: ${(props) => props.left};
    margin-left: ${(props) => props.mLeft};
    display: block;
    background-color: white;
  }
  @media (min-width: ${(props) => props.endPx}) {
    display: none;
  }
  @media (max-width: ${(props) => props.startPx}) {
    display: none;
  }
`;

const SvgComponentLogo = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 84 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80.0368 2.07218C80.0362 1.71937 80.1403 1.37431 80.336 1.08071C80.5316 0.787111 80.81 0.558179 81.1358 0.422888C81.4617 0.287597 81.8203 0.252042 82.1664 0.320726C82.5125 0.38941 82.8303 0.559241 83.0798 0.808716C83.3293 1.05819 83.4991 1.37609 83.5678 1.72215C83.6365 2.06821 83.6009 2.42687 83.4656 2.75272C83.3304 3.07856 83.1014 3.35692 82.8078 3.55256C82.5142 3.7482 82.1692 3.85231 81.8164 3.85172C81.5809 3.85838 81.3465 3.8169 81.1276 3.72983C80.9087 3.64276 80.7098 3.51192 80.5432 3.34532C80.3766 3.17873 80.2458 2.9799 80.1587 2.76098C80.0716 2.54207 80.0302 2.30769 80.0368 2.07218ZM83.2732 2.07218C83.2702 1.78472 83.1822 1.50455 83.0203 1.26698C82.8585 1.0294 82.6299 0.845021 82.3635 0.737068C82.097 0.629115 81.8046 0.602408 81.523 0.660311C81.2414 0.718214 80.9833 0.858134 80.781 1.06246C80.5788 1.26678 80.4415 1.52638 80.3865 1.80856C80.3315 2.09073 80.3613 2.38287 80.4719 2.64819C80.5826 2.91351 80.7693 3.14014 81.0086 3.29956C81.2478 3.45898 81.5289 3.54405 81.8164 3.54407C82.0101 3.54827 82.2027 3.51294 82.3823 3.44026C82.5619 3.36758 82.7249 3.25907 82.8612 3.12134C82.9975 2.98361 83.1044 2.81955 83.1752 2.63917C83.246 2.45879 83.2793 2.26587 83.2732 2.07218ZM82.2899 2.96194L81.8103 2.16869H81.4876V2.96194H81.1558V1.07685H81.8676C81.9441 1.06829 82.0215 1.07609 82.0947 1.09971C82.1679 1.12333 82.2352 1.16224 82.2923 1.21386C82.3493 1.26547 82.3947 1.32862 82.4255 1.39912C82.4563 1.46961 82.4718 1.54585 82.4708 1.62277C82.4751 1.72424 82.4486 1.82462 82.3947 1.91074C82.3409 1.99687 82.2623 2.0647 82.1692 2.10536L82.6971 2.96194H82.2899ZM81.4876 1.87312H81.8224C82.0214 1.87312 82.124 1.77659 82.124 1.62277C82.124 1.46895 82.0154 1.37545 81.8224 1.37545H81.4876V1.87312Z"
      fill="white"
    />
    <path
      d="M0.000732422 18.6313V51.236H5.19456L10.3914 32.6052V0.000488281H5.19456L0.000732422 18.6313Z"
      fill="white"
    />
    <path
      d="M11.4553 18.6308V51.2355H18.6157L25.773 32.6047V0H18.6157L11.4553 18.6308Z"
      fill="white"
    />
    <path
      d="M26.8384 18.6308V51.2355H38.9724L51.1034 32.6047V0H38.9724L26.8384 18.6308Z"
      fill="white"
    />
    <path
      d="M52.1672 31.4857V51.2355H76.4322V0H72.6711L52.1672 31.4857Z"
      fill="white"
    />
    <path
      d="M27.0218 55.1567V85.1193H21.5625L4.95556 62.4981V85.1193H0V55.1567H5.45926L22.0662 77.7779V55.1567H27.0218Z"
      fill="white"
    />
    <path
      d="M52.6173 74.6042C52.6173 80.9683 47.7432 85.7067 41.3821 85.7067C34.9275 85.7067 30.0986 80.9683 30.0986 74.6042C30.0986 68.2401 34.9245 63.4595 41.3821 63.4595C47.7432 63.4595 52.6173 68.1888 52.6173 74.6042ZM47.8336 74.6042C47.8336 70.7254 45.1704 67.8812 41.3821 67.8812C37.5938 67.8812 34.8823 70.7254 34.8823 74.6042C34.8823 78.3955 37.636 81.285 41.3821 81.285C45.1281 81.285 47.8336 78.3955 47.8336 74.6042Z"
      fill="white"
    />
    <path
      d="M76.3538 54.918V85.1188H71.5702V83.1794C70.0802 84.7598 67.6491 85.7069 64.9346 85.7069C58.0759 85.7069 54.1941 80.3804 54.1941 74.6044C54.1941 68.8285 58.0759 63.4597 64.9346 63.4597C67.6491 63.4597 70.0802 64.4068 71.5702 65.9873V54.918H76.3538ZM65.2513 67.8874C61.5053 67.8874 58.9777 70.9549 58.9777 74.6105C58.9777 78.266 61.5053 81.2913 65.2513 81.2913C68.545 81.2913 71.7512 79.1256 71.7512 74.6105C71.7512 70.0953 68.545 67.8874 65.2513 67.8874Z"
      fill="white"
    />
  </svg>
);

const LandingPr = ({ playing, videoUrl, headingText }) => {
  /*maxHeight.. le da el valor maximo que puede tener la pantalla se lo envia por props a styled-components. 
  de esa manera todos los contenedores padres de landing se acomodan al alto del video.
  y cuando llegan al maximo de la pantalla no crecen mas y ya el video se ajusta al alto del div padre.*/
  const [maxHeight, setMaxHeight] = useState(window.innerHeight);

  const ContainerTextLandingRef = useRef(null);

  let screen = useSelector((state) => state.screen.value);

  useEffect(() => {
    // Función para actualizar el valor de maxHeight
    //                        altura maxima  - altura de barra sistema inferior - altura barra explorador superior
    const maxPossibleHeight =
      window.screen.availHeight - 70 - window.outerHeight;

    // Actualizamos el estado solo si window.innerHeight es mayor o igual a maxPossibleHeight
    if (window.innerHeight >= maxPossibleHeight) {
      setMaxHeight(window.innerHeight);
    } else {
      // Si window.innerHeight es menor que maxPossibleHeight, actualizamos el estado con maxPossibleHeight
      setMaxHeight(maxPossibleHeight);
    }
  }, []);

  useEffect(() => {
    if (screen == 'FullScreen') {
      gsap.to(ContainerTextLandingRef.current, {
        translateX: '-100%',
        duration: 0.5,
      });
    }
    if (screen == 'Normal') {
      gsap.to(ContainerTextLandingRef.current, {
        translateX: '-0%',
        duration: 0.5,
      });
    }
    if (screen == 'FullScreenCellphone') {
      gsap.to(ContainerTextLandingRef.current, {
        translateX: '-100%',
        duration: 0.5,
      });
    }
  }, [screen]);

  const isMediaQueryMenor769px = useMediaQuery('(max-width: 769px)');
  const isMediaQueryMayor769px = useMediaQuery('(min-width: 769px)');

  const [mainPlaying, setMainPlaying] = useState(false);

  useEffect(() => {
    setMainPlaying(playing);
  }, [playing, mainPlaying]);

  const dispatch = useDispatch();

  return (
    <>
      <ContLanding maxHeight={maxHeight} id="Landing" zoom={screen}>
        <GlobalStyle />

        <ContVidLanding
          onClick={() => SpyGA('Clicked', 'VIDEO_HOME_SECTION1_CLICKED')}
        >
          {isMediaQueryMayor769px && (
            <FuncVideo playing={mainPlaying} disp={'desk'} url={videoUrl} />
          )}
          {isMediaQueryMenor769px && (
            <FuncVideo playing={mainPlaying} disp={'phone'} url={videoUrl} />
          )}
        </ContVidLanding>

        <ContainerAllAboutDelivery
          style={{
            cursor: isMediaQueryMayor769px
              ? mainPlaying
                ? `url(${punteroImgPlay}), pointer`
                : `url(${punteroImgStop}), pointer`
              : '',
          }}
          onClick={() =>
            isMediaQueryMayor769px
              ? setMainPlaying(!mainPlaying) & dispatch(FullScreen())
              : ''
          }
          maxHeight={maxHeight}
          ref={ContainerTextLandingRef}
          zoom={screen}
        >
          <CointLogoGrand>
            <SvgComponentLogo />
          </CointLogoGrand>

          <ContainerText>
            <AllADContGridLogText>
              <DivDer>
                <LogoChico />
                <VLine top="5px" hSize="95%" />
              </DivDer>

              <DivIzq>
                <AllAboutDeliveryContainerTexto>
                  {headingText}
                </AllAboutDeliveryContainerTexto>
              </DivIzq>
            </AllADContGridLogText>

            <ContainerLine>
              <HLineMinMax
                startPx="69px"
                endPx="3000px"
                width="100%"
                left="0px"
                mBottom="0px"
              />
            </ContainerLine>
          </ContainerText>
        </ContainerAllAboutDelivery>
      </ContLanding>
    </>
  );
};
export default LandingPr;
